export default __webpack_public_path__ + "static/media/info_red.9537db18.svg";